import { render, staticRenderFns } from "./feedback_display.vue?vue&type=template&id=8ac6bad6&scoped=true&"
import script from "./feedback_display.vue?vue&type=script&lang=js&"
export * from "./feedback_display.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ac6bad6",
  null
  
)

export default component.exports